import React, { useEffect, useRef, useState } from 'react'

import useTranslation from '../../context/hooks/useTranslation'
import { useScanMutation } from '../../redux/services/morning-scan'
import BarcodeIcon from '../../vectors/BarcodeIcon'
import ScanResult from '../ScanResult'

export interface ScanInputProps {
  subcoId: number
}

export const ScanInput: React.FC<ScanInputProps> = ({ subcoId }) => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)

  const [scan, { isLoading }] = useScanMutation({
    fixedCacheKey: 'scan',
  })

  const [barcode, setBarcode] = useState('')

  const handleBarcode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBarcode(e.currentTarget.value.trim())
  }

  const handleScan = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      scan({
        subcoId,
        trunkrsNrOrBarcode: barcode,
      })
        .unwrap()
        .then((result) => {
          // Small hack to make sure we get the shipmentData, sometimes /morning-scan
          // does not return this on initial scan so we have to retry
          if (!result.shipmentData) {
            scan({
              subcoId,
              trunkrsNrOrBarcode: barcode,
            })
          }
        })

      setBarcode('')
    }
  }

  useEffect(() => {
    if (barcode === '') {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 1000)
    }
  }, [barcode, isLoading])

  return (
    <>
      <div className="shadow-elevation-2 flex w-full flex-row items-center gap-2 rounded-lg border border-gray-50 bg-white px-4 focus-within:border-violet-50 hover:border-violet-50">
        <BarcodeIcon />
        <input
          ref={inputRef}
          value={barcode}
          disabled={isLoading}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          onChange={handleBarcode}
          className="font-body text-gray-90 h-14 w-full text-lg outline-none disabled:bg-white"
          placeholder={
            isLoading
              ? t('RETURNS_SCAN.LOADING')
              : t('RETURNS_SCAN.SCAN_INPUT_PLACEHOLDER')
          }
          onKeyDown={handleScan}
        />
      </div>

      <ScanResult />
    </>
  )
}

export default ScanInput
